require("reading/books/book_cover.scss");

var CurrentUser = require("lib/account/CurrentUser");
var ReactTooltip = require("react-tooltip");
var ReadingLevelIcon = require("components/reading/reading_levels/ReadingLevelIcon");

var BookCover = function (props) {
	var coverWidth = props.coverWidth || 98;

	var imgStyle = { width: coverWidth, height: "auto" };
	var missingBookCover = props.book.cover_url == null || props.book.cover_url.includes("nophoto");

	if (props.showTitle || props.showAuthor) {		
		if (props.showTitle) {
			var title = (
				<span className="title">{ props.book.title }</span>
			);
		}
		if (props.showAuthor) {
			var author = (
				<span className="author">{ props.book.author || props.book.author_full_name }</span>
			);
		}
		if (props.showReadingLevelIcon && props.book.lexile_score) {
			var readingLevel = (
				<ReadingLevelIcon studentReadingLevel={ CurrentUser.get().current_reading_level } 
					textReadingLevel={ props.book.lexile_score }  tooltipCopyType={ ReadingLevelIcon.STUDENT_VIEW } />
			)
		}
		var bookDetails = (
			<span className="bookDetails">
				{ title }{ author } { readingLevel }
			</span>
		);
	} else if (missingBookCover) {
		var bookDetails = (
			<span className="emptyCoverTitle">{ props.book.title }</span>
		)
	}

	if (missingBookCover) {
		var bookColors = ["red", "blue", "gold", "green", "orange", "purple"]
		var bookNumber = $wr.psuedoRandom("seed", bookColors.length)
		var coverUrl = require("reading/book-covers/book-" + bookNumber+ ".png");
	} else {
		var coverUrl = props.book.cover_url;
	}

	if (props.displayQuizTaken && !props.quizTaken && !props.teachersPick) {
		imgStyle["opacity"] = 0.55;
		if (props.quizDraft) {
			var quizTakenIcon = (
				<span className="b-tooltip" data-tip="Quiz in progress.">
					<img src={require("misc/quiz-draft.png") } className="quizTakenIcon" />
					<ReactTooltip effect="solid" offset={ { top: 15, right: coverWidth } } />
				</span>
			);
		}
	} else if (props.displayQuizTaken && props.quizTaken && !props.teachersPick) {
		var quizTakenIcon = (
			<span className="b-tooltip" data-tip="Quiz taken. Nice!">
				<img src={require("misc/quiz-complete.png") } className="quizTakenIcon" />
				<ReactTooltip effect="solid" offset={ { top: 15, right: coverWidth } } />
			</span>
		);
	} else if (props.displayQuizTaken && props.quizTaken && props.teachersPick) {
		var quizTakenIcon = (
			<span className="b-tooltip" data-tip="Quiz taken. Nice!">
				<img src={require("action-icons/teachers-picks.png")} className="quizTakenIconSquare" />
				<ReactTooltip effect="solid" offset={{ top: 15, right: coverWidth }} />
			</span>
		);
	} else if (props.displayQuizTaken && !props.quizTaken && props.teachersPick) {
		imgStyle["opacity"] = 0.55;
		var quizTakenIcon = (
			<span className="b-tooltip" data-tip="Quiz in progress.">
				<img src={require("action-icons/teachers-picks.png")} className="quizTakenIconSquare" />
				<ReactTooltip effect="solid" offset={{ top: 15, right: coverWidth }} />
			</span>
		);
	}

	return (
		<span className="bookCover">
			{ quizTakenIcon }
			<img src={ coverUrl } style={ imgStyle } />
			{ bookDetails }
		</span>
	);
}

BookCover.propTypes = StrictPropTypes({
	book: PropTypes.object.isRequired,
	coverWidth: PropTypes.number,

	// If true, the title will show
	showTitle: PropTypes.bool,
	// If true, the title will show
	showAuthor: PropTypes.bool,
	// If true, the missing cover title will never show
	noMissingCoverTitle: PropTypes.bool,

	teachersPick: PropTypes.bool,
	displayQuizTaken: PropTypes.bool,
	quizTaken: PropTypes.bool,
	quizDraft: PropTypes.bool,
	showReadingLevelIcon: PropTypes.bool
});


module.exports = BookCover;


// WEBPACK FOOTER //
// ./modules/components/reading/books/BookCover.js